import { Form, Input, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { SelectOption } from '~/app/components/errorManagement/ErrorManagementPage/types';

export interface VendorErrorCodeRequiredFieldsProps {
  manufacturerOptions: SelectOption[];
  assetTypeOptions: SelectOption[];
}

export function VendorErrorCodeRequiredFields({
  manufacturerOptions,
  assetTypeOptions,
}: VendorErrorCodeRequiredFieldsProps) {
  const { t } = useTranslation('errorManagement');

  return (
    <div
      style={{
        marginBottom: 16,
        padding: 16,
        borderRadius: 12,
        background: 'color-mix(in srgb, var(--evimo-blue) 6%, transparent)',
        border:
          '1px solid color-mix(in srgb, var(--evimo-blue) 18%, transparent)',
      }}
    >
      <Typography.Text
        strong
        style={{
          display: 'block',
          marginBottom: 12,
          color: 'var(--evimo-blue)',
        }}
      >
        {t('drawer.requiredSection')}
      </Typography.Text>
      <Form.Item
        name="manufacturerId"
        label={t('drawer.manufacturer')}
        rules={[{ required: true, message: t('drawer.required') }]}
      >
        <Select
          showSearch
          optionFilterProp="label"
          options={manufacturerOptions}
          placeholder={t('drawer.manufacturer')}
        />
      </Form.Item>
      <Form.Item
        name="assetTypeId"
        label={t('drawer.assetType')}
        rules={[{ required: true, message: t('drawer.required') }]}
      >
        <Select
          showSearch
          optionFilterProp="label"
          options={assetTypeOptions}
          placeholder={t('drawer.assetType')}
        />
      </Form.Item>
      <Form.Item
        name="errorCode"
        label={t('drawer.errorCode')}
        rules={[{ required: true, message: t('drawer.required') }]}
        style={{ marginBottom: 0 }}
      >
        <Input />
      </Form.Item>
    </div>
  );
}
